<template>
  <div>
    <b-dropdown v-if = "isAuthenticated" position="is-bottom-left">

      <button class="btn btn-left-icon" slot="trigger">
        <user-icon :picture = "myUserInfo.picture"></user-icon>
        <b-icon icon="menu-down"></b-icon>
      </button>

      <div class="dropdown-content">
        <div class="dropdown-item explanation">
          <p class = "explanation">
            Usuario
            <span v-if="myUserInfo.name"> {{ myUserInfo.name }} </span>
            <span v-else> {{ myUserInfo.email }} </span>
          </p>
        </div>
        <router-link to="/user" class = "dropdown-item">
           <b-icon icon="book-open"></b-icon>
           <span>Mis proyectos</span>
        </router-link>

        <router-link to="/user/settings" class = "dropdown-item">
           <b-icon icon="pencil"></b-icon>
           <span>Configuración de usuario</span>
        </router-link>

        <router-link to="/logout" class = "dropdown-item">
          <b-icon icon="logout"></b-icon>
          <span>Salir de la sesión</span>
        </router-link>
      </div>

    </b-dropdown>
      <!--  <button v-if = "isAuthenticated" class = "btn btn-bg"><img class = "user" src = "/static/example/image.jpg"/></button> -->
    <button v-else class = "btn btn-bg-transparent btn-no-margin btn-left-icon" v-on:click = "showLogin">
      <span class = "material-icons md-24">person</span>
      <span>Acceder</span>
    </button>
  </div>
</template>

<script>
import UserIcon from './UserIcon'
export default {
  name: 'AuthMenu',
  data: () => ({
  }),
  components: {
    UserIcon
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    userId () {
      return this.$store.getters['auth/getUserId']
    },
    myUserInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    showLogin: function () {
      console.log('showlogin')
      this.$store.commit('setEditorConfigProperty', {'isShowingAuthDecider': true})
    }
  },
  created () {
    this.$store.dispatch('auth/initialize')
    if (this.$store.getters['auth/isAuthenticated']) this.$store.dispatch('user/fetchUserInfo')
  }
}
</script>

<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";

.btn {
  height: 56px;
}

</style>



// WEBPACK FOOTER //
// src/components/User/AuthMenu.vue